import ModuleNavattic from "./ModuleNavattic";

export default ModuleNavattic;
